import { getBaseThemeName } from "@/features/branding";
import BoringAvatar from "boring-avatars";
import clamp from "lodash/clamp";
import { useId, type SVGProps } from "react";
const ICON_SIZE = 512;
const UserFilledIcon = (props: SVGProps<SVGSVGElement>) => <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="UserFilledIcon" data-sentry-source-file="Avatar.tsx">
    <path d="M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z" data-sentry-element="path" data-sentry-source-file="Avatar.tsx"></path>
  </svg>;
export const Avatar = ({
  name,
  size = 32
}: {
  name: string;
  size?: number;
}) => {
  const maskId = useId();
  const iconScale = clamp(size / ICON_SIZE, 0, 1);
  const colors = getBaseThemeName() === "hkma" ? ["#4B1553", "#701a75", "#86198f", "#e879f9", "#167D8E", "#41696C", "#333439"] : ["#460809", "#9f0712", "#f54900", "#ffb900", "#ff2056", "#443334"];
  return <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="block" data-sentry-element="svg" data-sentry-component="Avatar" data-sentry-source-file="Avatar.tsx">
      <defs data-sentry-element="defs" data-sentry-source-file="Avatar.tsx">
        {/* Invert the icon mask to make it transparent */}
        <mask id={maskId} data-sentry-element="mask" data-sentry-source-file="Avatar.tsx">
          <rect width={size} height={size} fill="black" data-sentry-element="rect" data-sentry-source-file="Avatar.tsx" />
          <g transform={`scale(${iconScale})`} data-sentry-element="g" data-sentry-source-file="Avatar.tsx">
            <UserFilledIcon width={ICON_SIZE} height={ICON_SIZE} fill="white" data-sentry-element="UserFilledIcon" data-sentry-source-file="Avatar.tsx" />
          </g>
        </mask>
      </defs>
      <g mask={`url(#${maskId})`} data-sentry-element="g" data-sentry-source-file="Avatar.tsx">
        <BoringAvatar size={size} name={name} variant="marble" colors={colors} data-sentry-element="BoringAvatar" data-sentry-source-file="Avatar.tsx" />
      </g>
    </svg>;
};